import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {jwtDecode} from "jwt-decode";
import Api from "../util/API";

const token = localStorage.getItem("adminToken");

const initialState = {
  user: token && token.split('.').length === 3 ? jwtDecode(token) : null,
  token: token || null,
  loading: false,
  error: null,
};

export const loginUser = createAsyncThunk("auth/login", async (data, thunkAPI) => {
  try {
    const res = await Api.post("/admin/login", data);
    localStorage.setItem("adminToken", res.data.data.token);
    return res.data.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.response.data.message);
  }
});

export const fetchAdminProfile = createAsyncThunk("auth/fetchProfile", async (_, thunkAPI) => {
  try {
    const state = thunkAPI.getState();
    const admin = state?.adminAuth?.user;
    const adminId = admin?.userId || admin?.id;
    if (!adminId) {
      return thunkAPI.rejectWithValue("Missing admin id");
    }
    const res = await Api.get(`/admin/${encodeURIComponent(adminId)}`);
    return res?.data?.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.response?.data?.message || err.message);
  }
});

export const adminAuthSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout: (state) => {
      state.user = null;
      state.token = null;
      localStorage.removeItem("adminToken");
    },
    checkToken: (state) => {
      try {
        if (state.token && state.token.split('.').length === 3) {
          const decoded = jwtDecode(state.token);
          if (decoded.exp * 1000 < Date.now()) {
            state.user = null;
            state.token = null;
            localStorage.removeItem("adminToken");
          } else {
            state.user = decoded;
          }
        } else {
          state.user = null;
          state.token = null;
          localStorage.removeItem("adminToken");
        }
      } catch {
        state.user = null;
        state.token = null;
        localStorage.removeItem("adminToken");
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.token = action.payload?.token || null;
        if (action.payload?.admin) {
          state.user = action.payload.admin;
        } else if (state.token && state.token.split('.').length === 3) {
          state.user = jwtDecode(state.token);
        } else {
          state.user = null;
        }
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error?.message || "Login failed";
      })
      .addCase(fetchAdminProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAdminProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.user = action.payload ? { ...state.user, ...action.payload } : state.user;
      })
      .addCase(fetchAdminProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error?.message || "Failed to load admin";
      });
  },
});

export const { logout, checkToken } = adminAuthSlice.actions;
export default adminAuthSlice.reducer;
